$(function(){
  const initRelatedProductsSlider = function(){
    let params = {
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: false,
      navigation: {
          nextEl: ".related-products.page-container .swiper-button-next",
          prevEl: ".related-products.page-container .swiper-button-prev",
      },
      breakpoints: {
          600: {
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: {
              nextEl: ".related-products.page-container .swiper-button-next",
              prevEl: ".related-products.page-container .swiper-button-prev",
            }
          },
          840: {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
              nextEl: ".related-products.page-container .swiper-button-next",
              prevEl: ".related-products.page-container .swiper-button-prev",
            }
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
            navigation: {
              nextEl: ".related-products.page-container .swiper-button-next",
              prevEl: ".related-products.page-container .swiper-button-prev",
            }
          }
        }
    }
    
    var relatedProductsSwiper = new Swiper(`.related-products.page-container .related-products__product-carousel-container`, params);
    };

    const updateImageSrcSet = function(cloneDiv, cookieDescriptionStringArray){
      let cookieProductImageUrl =  `//www.branchfurniture.com/cdn/shop/${cookieDescriptionStringArray[1].trim()}`;
      let cookieProductHoverImageUrl = `//www.branchfurniture.com/cdn/shop/${cookieDescriptionStringArray[1].trim()}`;
      let srcSet = window.Branch.functions.returnSrcSet(cookieProductImageUrl);
      let hoverSrcSet = window.Branch.functions.returnSrcSet(cookieProductImageUrl);
      cloneDiv.querySelector('.product-image-container img').setAttribute('srcset', srcSet);

        if(cookieDescriptionStringArray[8]){
          cookieProductHoverImageUrl = `//www.branchfurniture.com/cdn/shop/${cookieDescriptionStringArray[8].trim()}`;
          hoverSrcSet = window.Branch.functions.returnSrcSet(cookieProductHoverImageUrl);
        }

        cloneDiv.querySelector('.product-tile__image-container .product-image-hover img').setAttribute('srcset', hoverSrcSet);
    }

    const updatePrice = function(cloneDiv, cookieDescriptionStringArray){
      let cookieProductPrice = cookieDescriptionStringArray[2].trim();
      let cookieProductPriceVaries = cookieDescriptionStringArray[3].trim();
      let cookieOriginalProductPrice = cookieDescriptionStringArray[10].trim();


      if(cloneDiv.querySelector('.product-tile__info-container .from')){
        cloneDiv.querySelector('.product-tile__info-container .from').remove();
      }

      
      let priceHtml = `${Shopify.formatMoney((Math.ceil(cookieProductPrice/100)*100), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
      let originalPriceHtml = cookieOriginalProductPrice == "" || cookieOriginalProductPrice == "0" ? null : `${Shopify.formatMoney((Math.ceil(cookieOriginalProductPrice/100)*100), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
      if(cookieProductPriceVaries == "t"){
        priceHtml = `${priceHtml}+`
      }
      cloneDiv.querySelector('.price .deal span[data-price="deal"]').innerHTML = priceHtml;
      if(originalPriceHtml != null){
        cloneDiv.querySelector('.price .retail span[data-price="retail"]').innerHTML = originalPriceHtml;
        cloneDiv.querySelector('.price .retail').setAttribute('data-visible', "true")
      } else {
        cloneDiv.querySelector('.price .retail span[data-price="retail"]').innerHTML = '';
        cloneDiv.querySelector('.price .retail').setAttribute('data-visible', "false")
      }
    }

    const updateSalesText = function(cloneDiv, cookieDescriptionStringArray){
      let productStillDiscounted = false;
      let cookieProductSaleText = cookieDescriptionStringArray[6].trim().replaceAll('*', ' ');
      let discountIndex;
      if(cookieProductSaleText.includes('#') == false){
        productStillDiscounted = true;
      } else {
        discountIndex = parseInt(cookieProductSaleText.split('#')[1])
      }
      if(discountIndex > 0){
        let productHandleData = JSON.parse(document.querySelector(`#discount-handles-object`).innerText);
        let handles = productHandleData[`discount_code_${discountIndex}_product_handles`];
        if(handles){
          let handlesArray = handles.replaceAll(' ', '').split(',');
          handlesArray.forEach((handle) => {
            if(handle == cookieDescriptionStringArray[0].trim()){
              productStillDiscounted = true;
            }
          })
        }
      }

      if(productStillDiscounted == false) {
        let cookieOriginalProductPrice = cookieDescriptionStringArray[10].trim();
        if(cookieOriginalProductPrice != "" || cookieOriginalProductPrice != "0"){
          cookieDescriptionStringArray[2] = cookieDescriptionStringArray[10];
          cookieDescriptionStringArray[10] = "0";
        }
      }

      let promoProduct = false
      let promoHandles = document.querySelector(`#related-products-promo-handles`) ? JSON.parse(document.querySelector(`#related-products-promo-handles`).innerText) : undefined;
      if(promoHandles && promoHandles.handles && promoHandles.handles.length > 0){
        promoHandles.handles.forEach((promoHandle) => {
          if(promoHandle == cookieDescriptionStringArray[0].trim()){
            promoProduct = true; 
          }
        })
      }

      if(cloneDiv.querySelector('.sale')){
        cloneDiv.querySelector('.sale').remove();
      }
      let codeDiscountMessage = window.Branch.functions.returnSalesTagText(cookieDescriptionStringArray[0].trim(), 'fromHandle');
      let displaySwatch = cookieProductSaleText !== '' && cookieProductSaleText !== 'n' && productStillDiscounted == true ? true : codeDiscountMessage != "" ? true : false;

      if(displaySwatch){
        let salesSwatchHtml = `<div data-display="true" ${promoProduct == true ? 'promo-style="true" promo-style-on-hover="true"': ''} data-sale-text="${cookieProductSaleText}" class="sale">${codeDiscountMessage != "" ? codeDiscountMessage : cookieProductSaleText.split('#')[0]}</div>`
        cloneDiv.querySelector('.product-image').insertAdjacentHTML('beforeend', salesSwatchHtml);
      }
    }

    const updateTileData = function(cloneDiv, cookieDescriptionStringArray, cookieProductHandle){
      let cookieProductUrl = cookieDescriptionStringArray[4].trim();
      let cookieProductTitle = cookieDescriptionStringArray[5].trim().replaceAll('*', ' ');
      let cookieVariantTitle = cookieDescriptionStringArray[7].trim().replaceAll('*', ' ');
      let cookieColorCombos = cookieDescriptionStringArray[9].trim().replaceAll('*', ' ');

      cloneDiv.querySelector('a').setAttribute('href',`/products/${cookieProductHandle}`);
      cloneDiv.querySelector('.title').innerHTML = `${cookieProductTitle}`;
      cloneDiv.querySelector('.product-tile__image-container .product-image').setAttribute('data-title', cookieProductTitle);
      cloneDiv.querySelector('.product-tile__image-container .product-image').setAttribute('data-variant', cookieVariantTitle);

      if(cloneDiv.querySelector('.product-available-colors')){
        cloneDiv.querySelector('.product-available-colors').innerHTML = `${cookieColorCombos}`;
      }
    }

    const insertNewSlide = function(cookieDescriptionStringArray, cookieProductHandle, newProductHandles, slidesReplaced, productAlreadyInList) {
      let slides = document.querySelectorAll('.related-products__product-carousel .product-tile');
    
      if (slides.length === 0) return;
    
      const firstSlide = slides[slidesReplaced - 1];
      const cloneDiv = firstSlide.cloneNode(true);
    
      let lastSlide = slides[slides.length - 1];
    
      if (productAlreadyInList) {
        let existingSlide = document.querySelector(`.related-products__product-carousel .product-tile a[href="/products/${cookieProductHandle}"]`);
        if (existingSlide) {
          lastSlide = existingSlide.closest('.product-tile');
        }
      }
    
      updateImageSrcSet(cloneDiv, cookieDescriptionStringArray);
      updateSalesText(cloneDiv, cookieDescriptionStringArray);
      updatePrice(cloneDiv, cookieDescriptionStringArray);
      updateTileData(cloneDiv, cookieDescriptionStringArray, cookieProductHandle);
    
      document.querySelector('.related-products__product-carousel').insertBefore(cloneDiv, firstSlide);
      lastSlide.remove();
      newProductHandles.push(cookieProductHandle);
    }

    const selectQualifyingRecentlyViewedProducts = function(cookieArray){
      let existingHandles = document.querySelector('.related-products.page-container').getAttribute('data-product-handles').split(',');
      let currentProductHandle = document.querySelector('.related-products.page-container').getAttribute('data-current-product-handle');
      let newProductHandles = [];
      let slidesReplaced = 0;

      cookieArray.forEach((cookieDescriptionString) => {
        if(cookieDescriptionString != "" ){
          let cookieDescriptionStringArray = cookieDescriptionString.split('@@');
          let cookieProductHandle = cookieDescriptionStringArray[0].trim();
          if(!newProductHandles.includes(cookieProductHandle) && cookieProductHandle !== currentProductHandle){
            slidesReplaced = slidesReplaced + 1;
            if(slidesReplaced < 4){
              insertNewSlide(cookieDescriptionStringArray, cookieProductHandle, newProductHandles, slidesReplaced, existingHandles.includes(cookieProductHandle)); 
            }
          } 
        }
      })
    }

    const updateSliderAriaLabels = function(){
      let updatedSlides = document.querySelectorAll('.related-products__product-carousel .product-tile');

      updatedSlides.forEach((updatedSlide, index) => {
        updatedSlide.setAttribute('aria-label', `${index + 1} / ${updatedSlides.length}`)
      })
    }

    const retrieveRecentlyViewProducts = function(){
      if(document.cookie.split("; ").find((row) => row.startsWith("shopify_recently_viewed_data="))){
        const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("shopify_recently_viewed_data="))
        ?.split("=")[1];

        let cookieString = decodeURIComponent(cookieValue).trim();
        let cookieArray = cookieString.split('|||'); 

        if(cookieArray.length > 0){
          selectQualifyingRecentlyViewedProducts(cookieArray);
          updateSliderAriaLabels();
        }
      }
    }

    const initRelatedProducts = function(){
      initRelatedProductsSlider(); 

      if(document.querySelector(`.related-products.page-container[data-recently-viewed="true"]`)){
        retrieveRecentlyViewProducts();
      }
    }
    window.onload = initRelatedProducts(); 
});
